import { cart } from "./cart";
import { categoriesAndProperties } from "./categoriesAndProperties";
import { contactAndLegal } from "./contactAndLegal";
import { errors } from "./errors";
import { general } from "./general";
import { home } from "./home";
import { historicalData } from "./historicalData";
import { orders } from "./orders";
import { product } from "./product";
import { productRequest } from "./productRequest";
import { requirementsAidsdt } from "./requirementsAidsdt";
import { search } from "./search";
import { userProfile } from "./userProfile";

export const gr = {
  ...general,
  ...home,
  ...product,
  ...search,
  ...categoriesAndProperties,
  ...contactAndLegal,
  ...userProfile,
  ...cart,
  ...productRequest,
  ...requirementsAidsdt,
  ...historicalData,
  ...orders,
  ...errors,
};
